import styled from "styled-components";

export const LoadingContainer = styled.div(({ theme }) => ({
    margin: `calc(${theme.spacing.medium}) 0 0`,
    height: "100%",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));

export const SavingWidgetWrapper = styled.div(({ theme }) => ({
    padding: `${theme.spacing.large} ${theme.spacing.medium} 0 ${theme.spacing.medium}`,
}));

export const GroupCartContainer = styled.div(({ theme }) => ({
    padding: `${theme.spacing.large} ${theme.spacing.medium} 0 ${theme.spacing.medium}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
}));
